var optionsTimer;
var resetTimer;
var remove_button_onclick = false;

(function($){

    //remove global body loading
  setTimeout(function(){document.querySelector('body').classList.remove('unloading')}, 500);

  $( document ).ajaxComplete(function( event, xhr, settings ) {    
    if ( settings.url.indexOf('/cart.js') == 0 && location.pathname.indexOf('/cart') == 0) {            
      $('.cart__row td').contents().filter(function() {     
        return this.nodeType === 3 && $.trim(this.textContent).length
      }).wrap('<p class="meta">'); // wrap filtered element with p
      
      $('.cart__row td p.meta').each(function(){
        let _c = $(this).text().split(':');
        $(this).addClass(_c[0]);
      })
    }
    
  });
  
  
  function render_options() {
    if($('#SingleOptionSelector-0').length && !$('#SingleOptionSelector-0').parent('.selector-wrapper').hasClass('hide')) {
      var options = '<div class="option_title"><strong>SCENT</strong><span>select one</span></div><ul id="single-option-icons"></ul>';
      $(options).insertAfter('.product-details-wrapper .icons');
      $('#SingleOptionSelector-0 option').each(function(){
        let opt = $(this).val();
        let icon_class =  opt.replace(/[^0-9a-z]/gi, '-').toLowerCase();        
        let all_classes = icon_class;
        $(this).attr('data-iconclass', icon_class);
        if ($(this).attr('selected')) {
          all_classes += ' active';
        }
        let option = '<li><div class="tooltip">'+$(this).val()+'</div><a href="#'+icon_class+'" data-iconclass="'+icon_class+'" class="'+all_classes+'" data-option="'+$(this).val()+'"></a></li>';      
        $('#single-option-icons').append(option);
      });      
      
      clearInterval(optionsTimer);
      $('#single-option-icons a').off('click');
      $('#single-option-icons a').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();        
        let _class = $(this).data('iconclass');
        $('#single-option-icons a').removeClass('active');
        $(this).addClass('active');
        $('#SingleOptionSelector-0 option').removeAttr('selected');
        $('#SingleOptionSelector-0 option[data-iconclass="'+_class+'"]').attr('selected', 'selected');                
        $('#SingleOptionSelector-0').val($(this).data('option')).trigger('change').trigger('click');      
        return false;
      });

      $.smoothScroll = function(){};
    }
    if($('.product-details-wrapper [itemprop="offers"]').length) {
      if(!$('.product-details-wrapper [itemprop="offers"]').hasClass('product-details--form-wrapper---out-of-stock')){
        $('.product-details-wrapper [itemprop="offers"]')
        .prepend('<div class="option_title"><strong>FREQUENCY</strong><span >select one</span></div>');  
      }      
      clearInterval(optionsTimer);
    }
  }
  optionsTimer = setInterval(render_options, 1000);
})(jQuery);

(function ($, wetheme) {
    function click1(){
      console.log('reset1');     
      
      remove_button_onclick = true;
      wetheme.$('[id*="list-Wipe Type"] input[type="checkbox"][aria-checked=true]').each(function(){
        const _self = this;
        setTimeout(function(){
            wetheme.$(_self).trigger('click');
        }, 100);
      });    
    }

    //wetheme.$(document.body).on('click', '.sajari-1c7y72t:eq(1)  button.clone', function(e){
    function click2(){
      console.log('reset2');      
      
      remove_button_onclick = true;
      wetheme.$('[id*="list-Scents"] input[type="checkbox"][aria-checked=true]').each(function(){
        const _self = this;
        setTimeout(function(){
            wetheme.$(_self).trigger('click');
        }, 100);
      });
    }
  
  function listen_reset(){
    if (jQuery('.sajari-1c7y72t:eq(0) button.clone').length == 0) {      
      jQuery('.sajari-1c7y72t:eq(0)')
      .append('<button class="clone hide">RESET</buton>');        

      jQuery('.sajari-1c7y72t:eq(0) .clone').off().on('click', function(e){
        e.preventDefault(); 
        e.stopPropagation();
        click1();
      });
    }

    if (jQuery('.sajari-1c7y72t:eq(1) button.clone').length == 0) {      
      jQuery('.sajari-1c7y72t:eq(1)')
      .append('<button class="clone hide">RESET</buton>');
      jQuery('.sajari-1c7y72t:eq(1) .clone').off().on('click', function(e){
        e.preventDefault(); 
        e.stopPropagation();
        click2();
      });
    }  
  }
  
  function toggle_clone_buttons() {
    if(jQuery('.sajari-1c7y72t.first button').length == 2) {
      jQuery('.sajari-1c7y72t.first button.clone').removeClass('hide');
    } else {
      jQuery('.sajari-1c7y72t.first button.clone').addClass('hide');
    }

    if(jQuery('.sajari-1c7y72t.last button').length == 2) {
      jQuery('.sajari-1c7y72t.last button.clone').removeClass('hide');
    } else {
      jQuery('.sajari-1c7y72t.last button.clone').addClass('hide');
    }
  }

   function set_observer() {
    if (document.querySelector('.sajari-1c7y72t')) {
      jQuery('.sajari-1c7y72t:eq(0)').addClass('first');      
      if (jQuery('.sajari-1c7y72t:eq(1)').length){
        jQuery('.sajari-1c7y72t:eq(1)').addClass('last');
      }
      
      document.querySelector('.sajari-1c7y72t')
      listen_reset();
      toggle_clone_buttons();
      clearInterval(resetTimer);
    } else {
      return;
    }
    
    const config = { attributes: false, childList: true, subtree: true };      
    const callback = function(mutationList, observer) {
      // Use traditional 'for loops' for IE 11
      for(const mutation of mutationList) {
        if (mutation.type === 'childList') {
          toggle_clone_buttons();
          console.log('A child node has been added or removed.');
        }              
      }
    };
     
    const targetNode1 = document.querySelector('.sajari-1c7y72t.first');      
    const observer1 = new MutationObserver(callback);          
    observer1.observe(targetNode1, config);    

    if (document.querySelector('.sajari-1c7y72t.last')) {
      const targetNode2 = document.querySelector('.sajari-1c7y72t.last');      
      const observer2 = new MutationObserver(callback);          
      observer2.observe(targetNode2, config);      
    }    
  }
  
  resetTimer = setInterval(set_observer, 1000);
  
  if (location.pathname.indexOf('/collections/') == 0){
    window.addEventListener('popstate', function(event, state){
        location.reload();
    }) 
  }
  
})(window.wetheme.$, window.wetheme);


